import { ActionTree, GetterTree, MutationTree } from "vuex";
import { IdOriginStoreType } from "../../types/IdOriginTypes";

const state: IdOriginStoreType = {
  utm: "",
  id: "",
  origin: "",
  utmMedium: "",
};

const getters: GetterTree<IdOriginStoreType, any> = {
  utm: (st) => st.utm,
  id: (st) => st.id,
  utmMedium: (st) => st.utmMedium,
  origin: (st) => st.origin,
};

const mutations: MutationTree<IdOriginStoreType> = {
  setUtm(st: IdOriginStoreType, utm) {
    st.utm = utm;
  },
  setId(st: IdOriginStoreType, id) {
    st.id = id;
  },
  setUtmMedium(st: IdOriginStoreType, utmMedium) {
    st.utmMedium = utmMedium;
  },
  setOrigin(st: IdOriginStoreType, origin) {
    st.origin = origin;
  },
};
const actions: ActionTree<IdOriginStoreType, any> = {
  async setUtm({ commit }, utm) {
    commit("setUtm", utm);
  },
  async setId({ commit }, id) {
    commit("setId", id);
  },
  async setUtmMedium({ commit }, utmMedium) {
    commit("setUtmMedium", utmMedium);
  },
  async setOrigin({ commit }, origin) {
    commit("setOrigin", origin);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
